import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";
import _ from "lodash";
class AcquisitionBookRestClient extends RestClient {
  async complete(uuid, form) {
    const url = this.buildUrl(`${uuid}/complete`);
    const response = await this.client.post(url, this.toSnake({ ...form }));
    return this.toCamel(response.data);
  }

  handleSpecialSnakeCase(data) {
    const mapping = {
      o_2_threshold: "o2_threshold",
      c_3_h_8: "c3_h8",
      o_2: "o2",
      co_2: "co2",
      ch_4: "ch4",
      so_2: "so2",
    };

    const transformKey = (key) => _.get(mapping, key, key);

    const recursiveTransform = (obj) => {
      if (_.isArray(obj)) {
        return obj.map(recursiveTransform);
      } else if (_.isPlainObject(obj)) {
        return _.mapKeys(_.mapValues(obj, recursiveTransform), (value, key) =>
          transformKey(key)
        );
      }
      return obj;
    };

    return recursiveTransform(data);
  }

  handleSpecialCamelCase(data) {
    const mapping = {
      c3H8: "c3h8",
    };

    const transformKey = (key) => _.get(mapping, key, key);

    const recursiveTransform = (obj) => {
      if (_.isArray(obj)) {
        return obj.map(recursiveTransform);
      } else if (_.isPlainObject(obj)) {
        return _.mapKeys(_.mapValues(obj, recursiveTransform), (value, key) =>
          transformKey(key)
        );
      }
      return obj;
    };

    return recursiveTransform(data);
  }
}

export const acquisitionBookRestClient = new AcquisitionBookRestClient(
  atmoClient,
  "acquisitionbooks"
);
